(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    

const DELAY = 1000;
// [positionSelector, (childSizeSelector)]
const CHECK_ELS = [
  ['#shopify-chat', ':first-child'],
  ["[class*='kl-teaser-']"],
];

const CHECK_POSITIONS = ['fixed', 'static'];

function sizeFooterShim() {
  const shimEl = document.querySelector('.eza-primary-footer-shim');
  if (!shimEl) return;

  const heights = CHECK_ELS.map(([positionElSelector, sizeElSelector]) => {
    const el = document.querySelector(positionElSelector);
    if (!el) return 0;
    const elStyle = window.getComputedStyle(el);
    if (!CHECK_POSITIONS.includes(elStyle.position)) return 0;
    let sizeEl;
    if (sizeElSelector) {
      sizeEl = el.querySelector(sizeElSelector);
      if (!sizeEl) return 0;
    }
    if (!sizeEl) sizeEl = el;
    if (!sizeEl.style.bottom) return 0;
    return sizeEl.offsetHeight + (parseInt(sizeEl.style.bottom) || 0);
  });

  shimEl.style.height = `${Math.max(...heights)}px`;
}

function debounce(func, delay) {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

const debouncedSizeFooterShim = debounce(sizeFooterShim, DELAY);

debouncedSizeFooterShim();

window.addEventListener('resize', debouncedSizeFooterShim);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
